module.exports = __webpack_public_path__ + "static/media/the-art-of-innovation.53683d5e.svg";